import { Box } from '@mui/material';
import FreeWinningAnimationMp4 from 'assets/splash/win.mp4';
import FreeWinningAnimationWebm from 'assets/splash/win.webm';
import React, { FC, LegacyRef, useCallback, useRef } from 'react';
import { useStyles } from './WinningAnimation.styles';
import { PRIZE_ANIMATION_DELAY } from 'modules/tournaments/constants';
import { isSafari } from 'react-device-detect';

interface WinningAnimationProps {
  withPrize: boolean;
  onEnded: () => void;
  onShowResult: () => void;
}

export const WinningAnimation: FC<WinningAnimationProps> = ({
  withPrize,
  onEnded,
  onShowResult,
}) => {
  const { classes } = useStyles();
  const videoRef = useRef<HTMLVideoElement>();

  const onEndedHandler = useCallback(() => onEnded(), [onEnded]);

  const onTimeUpdateHandler = useCallback(() => {
    if (!videoRef?.current) {
      return;
    }

    if (withPrize && (videoRef.current?.currentTime ?? 0) >= PRIZE_ANIMATION_DELAY) {
      return onShowResult();
    }

    if ((videoRef.current?.currentTime ?? 0) >= (videoRef.current?.duration ?? 0) - 2.5) {
      return onShowResult();
    }
  }, [onShowResult, withPrize]);

  // https://olafwempe.com/how-to-enable-audio-and-video-autoplay-with-sound-in-chrome-and-other-browsers-in-2019/
  // A visitor must interact with the site before audio can play. A click anywhere on the site is enough.
  return (
    <Box className={classes.root}>
      <video
        autoPlay
        ref={videoRef as LegacyRef<HTMLVideoElement>}
        className={classes.video}
        onTimeUpdate={onTimeUpdateHandler}
        onEnded={onEndedHandler}
      >
        {isSafari ? (
          <source src={FreeWinningAnimationMp4} type='video/mp4; codecs="hvc1"' />
        ) : (
          <source src={FreeWinningAnimationWebm} type="video/webm" />
        )}
        <p>Your browser doesn&#39;t support HTML video.</p>
      </video>
    </Box>
  );
};
